<div
    class="!tw-border-1 !tw-border-gray-600 tw-flex tw-flex-col tw-gap-[26px] tw-pt-[40px] tw-pb-[40px] tw-bg-[#024B3F0A] lg:tw-pl-[140px] md:tw-pl-[66px] tw-pl-[28px] lg:tw-pr-[80px] md:tw-pr-[45px] tw-pr-[28px]"
>
    <div
        class="tw-flex tw-justify-start md:tw-justify-center tw-items-start md:tw-items-center"
    >
        <span class="tw-text-[28px] tw-font-bold tw-text-[#024B3F]">
            {{ "What's New?" }}
        </span>
    </div>
    <p-carousel
        [value]="displayData"
        [numVisible]="1"
        [numScroll]="1"
        [circular]="true"
        [showNavigators]="true"
        contentClass="whats-new-carousel tw-w-full"
        [showIndicators]="true"
        [autoplayInterval]="1150000"
    >
        <!-- Custom Previous Button -->
        <ng-template pTemplate="previousicon">
            <mat-icon
                aria-hidden="false"
                aria-label="Prev Button"
                fontIcon="chevron_left"
            ></mat-icon>
        </ng-template>

        <!-- Custom Next Button -->
        <ng-template pTemplate="nexticon">
            <mat-icon
                aria-hidden="false"
                aria-label="Next Button"
                fontIcon="chevron_right"
            ></mat-icon>
        </ng-template>
        <ng-template let-item pTemplate="item" let-i="index">
            <app-carousel-item
                [desktop]="item.image"
                [portrait]="item.pImage"
                [mobile]="item.mImage"
                [title]="item.title"
                [description]="item.description"
                [link]="item.link"
                [linkText]="item.linkText"
            ></app-carousel-item>
        </ng-template>
    </p-carousel>
</div>
